import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { InView } from 'react-intersection-observer'
import { Accordion, RectangleSkeleton, Button } from '@sainsburys-tech/bolt'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'
import { scrollToAccordion } from '../../helpers/openAccordion'
import generateCNETScript from '../../helpers/generateCNETScript'
import { loadScript } from '../../utils'

import * as Styled from './CNETAccordion.styles'

const CNETAccordion = props => {
  const [cnetContentPresent, setCnetContentPresent] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)

  const { headerText, partNumber, onAccordionChange } = props
  const previewContent = <Styled.Header data-test='cnet-accordion-header'>{headerText}</Styled.Header>

  const injectCnetContent = injectPartNumber => {
    const scriptOptions = {
      src: 'https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js',
      crossOrigin: 'anonymous',
      defer: true
    }

    const cnetContent = () => {
      const cnetScript = document.createElement('script')
      cnetScript.type = 'text/javascript'
      cnetScript.text = generateCNETScript(injectPartNumber)
      document.head.appendChild(cnetScript)
    }

    loadScript('jq', scriptOptions, cnetContent)
  }

  const embedContentAndTrack = () => {
    if (!cnetContentPresent) {
      injectCnetContent(partNumber)

      // Adobe Analytics Tracking Code
      pushEventAndTrack({
        eventInfo: {
          eventName: 'pdp_showMore_partiallyOpened',
          eventAction: headerText
        }
      })
      setCnetContentPresent(true)
    }
  }

  const toggleContent = () => {
    setIsExpanded(!isExpanded)
    pushEventAndTrack({
      eventInfo: {
        eventName: 'pdp_showMore_ctaClick',
        eventAction: headerText
      }
    })
  }

  const handleAccordion = show => {
    onAccordionChange('cnet', show)

    if (show) scrollToAccordion('#cnet-accordion')
  }

  const accordionOptions = {
    title: previewContent,
    onClick: handleAccordion,
    name: 'cnet-accordion',
    'data-test': 'cnet-accordion',
    index: 'cnet-accordion'
  }

  return (
    <div id='cnet-accordion' style={{ position: 'relative' }}>
      <Accordion.Item isOpen as='h3' hasBorderBottom noAnimation {...accordionOptions}>
        <Styled.Container isExpanded={isExpanded}>
          <InView onChange={inView => inView && embedContentAndTrack()}>
            <div id='ccs-inline' data-test='cnet-accordion-container'>
              <RectangleSkeleton height={50} />
              <RectangleSkeleton height={50} />
            </div>
          </InView>
        </Styled.Container>
        <Styled.ButtonWrapper isExpanded={isExpanded}>
          <Button kind='secondary' onClick={toggleContent}>
            {isExpanded ? 'Show less' : 'Show more'}
          </Button>
        </Styled.ButtonWrapper>
      </Accordion.Item>
    </div>
  )
}

CNETAccordion.propTypes = {
  headerText: PropTypes.string,
  onAccordionChange: PropTypes.func
}

CNETAccordion.defaultProps = {
  headerText: 'More Details',
  onAccordionChange: () => {}
}

export default CNETAccordion
